module.exports = __webpack_public_path__ + "static/sczeplenie-1e67878ed57aa391f378ade77e20cace.webp";